import React from "react"
import PropTypes from "prop-types"

import lottie from 'lottie-web';

class BtnSecondary extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      buttonText: "Submit"
    }
  }

  componentDidUpdate() {
    if(this.props.loading) {
      lottie.loadAnimation({
        container: document.getElementById(`loader`),
        renderer: 'svg',
        loop: true,
        autoplay: true,
        name: `loader`,
        path: this.props.loaderLottie,
      })
    } else {
      lottie.destroy('loader')
    }
  }

  buttonText() {
    if(!this.props.loading) {
      return this.props.buttonText
    }
    else return null
  }

  componentWillUnmount() {
    lottie.stop('loader')
  }

  render() {
      return(<button className="button_secondary" onClick={() => this.props.onClick()} id="loader">{this.buttonText()}</button>)
  }
}

export default BtnSecondary;
